import React from "react";
import './Pitch.css';

export default function Pitch () {
    
    return (
        <div className="pitch-container">
            <h1 className="pitch-title">Why?</h1>
            <p className="pitch-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl nec aliquam aliquam, nunc nisl aliquet nunc, eget aliquam nisl nisl sit amet lorem. Sed euismod, nisl nec aliquam aliquam, nunc nisl aliquet nunc, eget aliquam nisl nisl sit amet lorem.
            </p>
        </div>
    )
}